import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import Integrations from "../../../integration/Integrations.jsx";
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'

import GlobalHelper from '../../../common/GlobalHelper.jsx'
import { BILLING_TYPE } from '../../../state/invoice/InvoiceBillingType';

class InvoiceExportedToShopifyEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            invoice: this.props.invoice || null,
            proposal: this.props.proposal || null,
            modal: '',
            parentInvoiceExternalLink: null,
        }
    }

    componentDidMount() {
        this.fetchParentInvoice()
    }

    fetchParentInvoice() {
        const parentInvoiceId = this.state.invoice.attributes.returnOfInvoiceId
        if (parentInvoiceId) {
            AppContext.getApiClient().get("/invoices/" + parentInvoiceId).then(res => {
                const link = GlobalHelper.getObjectExternalLink(res, this.state.object.attributes.integrationKey)

                if (link) {
                    this.setState({
                        parentInvoiceExternalLink: link
                    })
                }
            })
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            invoice: nextProps.invoice || null,
            proposal: nextProps.proposal || null,
        })
    }

    renderMessage() {
        let type = this.state.object.attributes.entityType
        if (this.isStandaloneReturn()) {
            type = 'inventory-adjustment'
        }
        switch (type) {
            case 'main':
                return !this.isReturn() ?
                    <FormattedMessage
                        id="invoice.analytics.events.exported.shopify.text"
                        defaultMessage="Invoice {identifier} has been exported to Shopify as a completed order"
                        values={{
                            identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                        }}
                    /> : <FormattedMessage
                        id="invoice.analytics.events.return_exported.shopify.text"
                        defaultMessage="Return {identifier} has been exported to Shopify as a completed order"
                        values={{
                            identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                        }}
                    />
            case 'void':
                return <FormattedMessage
                    id="invoice.analytics.events.exported.shopify.void_text"
                    defaultMessage="Invoice {identifier} has been refunded in Shopify"
                    values={{
                        identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                    }}
                />
            case 'invoice-adjustment':
            case 'payment-adjustment':
                return <span>
                    <FormattedMessage
                        id="invoice.analytics.events.exported.shopify.adjustment_text"
                        defaultMessage="An adjustment for {identifier} has been made in Shopify"
                        values={{
                            identifier: <strong>{this.state.invoice.attributes.identifier}</strong>,
                        }}
                    />
                    {this.state.object.attributes.metadata && this.state.object.attributes.metadata.notes ?
                        <span className={'ml-1'}>
                            <span className={'mr-1'}>/</span>
                            <FormattedMessage
                                id="invoice.analytics.events.exported.shopify.invoice_adjustment_notes"
                                defaultMessage="Reason: {notes}"
                                values={{
                                    notes: this.state.object.attributes.metadata.notes,
                                }}
                            />
                        </span> : ''}
                </span>
            case 'inventory-adjustment':
                return (
                    <FormattedMessage
                        id="invoice.analytics.events.exported.shopify.standalone_return_inventory_adjustment"
                        defaultMessage="Return exported to shopify as inventory adjustment"
                    />
                )

        }
        return ''
    }

    isReturn() {
        return this.state.invoice && this.state.invoice.attributes.billingType === BILLING_TYPE.RETURN
    }

    isStandaloneReturn() {
        return this.isReturn() && !this.state.invoice.attributes.returnOfInvoiceId
    }


    render() {
        const shopifyUrl = this.isReturn() ?
            Integrations.getPaymentTransactionExternalUrl(this.state.parentInvoiceExternalLink) :
            Integrations.getPaymentTransactionExternalUrl(this.state.object)

        return <div className={"row " + this.state.className}>
            <div className={'col-12'}>
                <p className={'mb-2'}>
                    {this.renderMessage()}
                </p>
            </div>

            <div className={'col-12 d-flex align-items-center flex-wrap'}>
                <div className={'mr-3'}>
                    <a href={shopifyUrl} target="_blank">
                        <img src="/images/shopify_logo.png" width="100px" />
                    </a>
                </div>

                {
                    shopifyUrl &&
                    <div >
                        <p className={'mb-0'}>
                            <a href={shopifyUrl} target={'_blank'} className={'btn btn-sm btn-outline-primary'}>
                                <FormattedMessage
                                    id="invoice.analytics.events.exported.shopify.open"
                                    defaultMessage="Open order in shopify"
                                />
                            </a>
                        </p>
                    </div>
                }
            </div>
        </div>
    }

}

export default InvoiceExportedToShopifyEvent



// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-exported-shopify.component.jsx